export default __webpack_public_path__ + "static/media/Coins-Square.1e7e0446.svg";